import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Button, Chip, Divider, Grid2, IconButton, Paper, Stack, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme, } from '@mui/material';
import { IoMdClose } from 'react-icons/io';
import { useParams } from 'react-router-dom';
import PaginationComponent from 'components/ui-components/PaginationComponent';
import TableDataGrid from 'components/grid/TableDataGrid';
import moment from 'moment';
import ExportToExcel from "../ExportToExcel";
import ExportToPDF from "../ExportToPDF";
import { useGetNcrFilteredListQuery } from "store/slices/apis/qualityDashboardSlice";

export default function NcrPopup({ title, value, status, onClose, onOpen }) {

    const { projectId } = useParams();
    const [pageNumber, setPageNumber] = React.useState(1);

    let searchparams = {
        projectId: projectId,
        page: pageNumber,
        pageSize: 10,
        sortBy: 'CreatedDate',
        sortOrder: 'desc',
    }

    if (status == 'Total NCR') {
        searchparams = {
            ...searchparams
        }
    }
    else if (status == 'Open Ncr') {
        const now = new Date();
        const firstDay = new Date(Date.UTC(now.getFullYear(), now.getMonth(), 1, 0, 0, 0));
        const lastDay = new Date(Date.UTC(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59));
        searchparams = {
            ...searchparams,
            currentStatus: 'Open',
            // from: firstDay.toISOString(),
            // to: lastDay.toISOString(),
        }
    }
    else if (status == 'Closed Ncr') {
        const now = new Date();
        const firstDay = new Date(Date.UTC(now.getFullYear(), now.getMonth(), 1, 0, 0, 0));
        const lastDay = new Date(Date.UTC(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59));
        searchparams = {
            ...searchparams,
            currentStatus: "Close",
            // from: firstDay.toISOString(),
            // to: lastDay.toISOString(),
        };
    }

    else if (status == 'ClosedAgeingAnalysis') {
        searchparams = {
            ...searchparams,
            delayDaysMin: value.delayDaysMin,
            delayDaysMax: value.delayDaysMax,
            currentStatus: 'Close',
        }
    }
    else if (status == 'DistributedOpenNcr') {
        searchparams = {
            ...searchparams,
            category: value,
            currentStatus: 'Open',
        }
    }
    else {
        searchparams = {
            ...searchparams,
        }
    }

    const { data: openCloseData = {}, error: openCloseError, isLoading: isOpenCloseLoading } = useGetNcrFilteredListQuery(searchparams);

    const popupdata = openCloseData?.data || [];








    const columns = [
        {
            name: "Quality ID",
            field: "ncrNumber",
            renderer(params) {
                return (
                    <Stack direction="row" spacing={1}>
                        {params?.ncrNumber && (
                            <Chip
                                label={params?.ncrNumber}
                                size="small"
                                sx={{
                                    fontSize: "12px",
                                    "& .MuiChip-label": {
                                        paddingLeft: "8px",
                                        paddingRight: "8px",
                                        fontWeight: 600,
                                    },
                                }}
                            />
                        )}
                    </Stack>
                );
            },
            renderExport(row) {
                return row?.ncrNumber || "";
            },
        },
        {
            name: "Workflow Status",
            field: "workflowStatus",
            renderer(params) {
                return (
                    <>
                        {params?.workflowStatus === "Pending_for_Approval"
                            ? "Pending for approval"
                            : params?.workflowStatus}
                    </>
                );
            },
            renderExport(row) {
                return row?.workflowStatus === "Pending_for_Approval"
                    ? "Pending for approval"
                    : row?.workflowStatus || "";
            },
        },
        {
            name: "Current status",
            field: "currentStatus",
            renderExport(row) {
                return row?.currentStatus || "";
            },
        },
        {
            name: "Created Date",
            field: "createdDate",
            renderer(params) {
                return params?.createdDate
                    ? moment(params.createdDate).format("DD/MM/YY")
                    : "N.A.";
            },
            renderExport(row) {
                return row?.createdDate
                    ? moment(row.createdDate).format("DD/MM/YY")
                    : "N.A.";
            },
        },
        {
            name: "Category",
            field: "subPackage2",
            renderExport(row) {
                return row?.subPackage2 || "";
            },
        },
        {
            name: "Date Of Issue Of NCR",
            field: "dateOfIssueOfNCR",
            renderer(params) {
                return params?.dateOfIssueOfNCR
                    ? moment(params.dateOfIssueOfNCR).format("DD/MM/YY")
                    : "N.A.";
            },
            renderExport(row) {
                return row?.dateOfIssueOfNCR
                    ? moment(row.dateOfIssueOfNCR).format("DD/MM/YY")
                    : "N.A.";
            },
        },
        {
            name: "Planned Date Of Corrective Action Compeltion",
            field: "plannedDateOfCorrectiveActionCompeltion",
            renderer(params) {
                return params?.plannedDateOfCorrectiveActionCompeltion
                    ? moment(params.plannedDateOfCorrectiveActionCompeltion).format("DD/MM/YY")
                    : "N.A.";
            },
            renderExport(row) {
                return row?.plannedDateOfCorrectiveActionCompeltion
                    ? moment(row.plannedDateOfCorrectiveActionCompeltion).format("DD/MM/YY")
                    : "N.A.";
            },
        },
        {
            name: "Actual Date Of Corrective Action Compeltion",
            field: "actualExpectedDateOfCorrectiveActionCompeltion",
            renderer(params) {
                return params?.actualExpectedDateOfCorrectiveActionCompeltion
                    ? moment(params.actualExpectedDateOfCorrectiveActionCompeltion).format("DD/MM/YY")
                    : "N.A.";
            },
            renderExport(row) {
                return row?.actualExpectedDateOfCorrectiveActionCompeltion
                    ? moment(row.actualExpectedDateOfCorrectiveActionCompeltion).format("DD/MM/YY")
                    : "N.A.";
            },
        },
        {
            name: "Planned Date Of NCR Close",
            field: "plannedDateOfNCRClose",
            renderer(params) {
                return params?.plannedDateOfNCRClose
                    ? moment(params.plannedDateOfNCRClose).format("DD/MM/YY")
                    : "N.A.";
            },
            renderExport(row) {
                return row?.plannedDateOfNCRClose
                    ? moment(row.plannedDateOfNCRClose).format("DD/MM/YY")
                    : "N.A.";
            },
        },

        {
            name: "NCR Raised By",
            field: "ncrRaisedBy",
            renderExport(row) {
                return row?.ncrRaisedBy || "";
            },
        },
    ];


    return (
        <React.Fragment>
            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                open={onOpen}
                sx={{
                    '& .MuiDialog-paper': {
                        overflowY: 'inherit'
                    }
                }}
            >
                <DialogTitle sx={{ fontSize: '20px', color: '#696969' }}>{title}</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <IoMdClose style={{ fontSize: '20px' }} />
                </IconButton>
                <Divider sx={{ w: 1 }} />
                <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <Grid2 container spacing={2}>
                            <Grid2 container spacing={2} size={12}>
                                <Grid2 xs={12} sm={6}>
                                    <ExportToExcel data={openCloseData?.data} columns={columns} fileName="quality_export" />
                                </Grid2>
                                <Grid2 xs={12} sm={6}>
                                    <ExportToPDF data={openCloseData?.data} columns={columns} fileName="quality_export" />
                                </Grid2>
                            </Grid2>
                            <Grid2 size={12}>
                                <TableDataGrid columns={columns} data={openCloseData?.data} isLoading={isOpenCloseLoading} />

                                <Box sx={{ display: "flex", justifyContent: "end" }}>
                                    <PaginationComponent
                                        pageNumber={openCloseData?.pagination?.currentPage || 1}
                                        totalPages={openCloseData?.pagination?.totalPages || 1}
                                        onPageChange={setPageNumber}
                                    />
                                </Box>

                            </Grid2>
                        </Grid2>
                    </Box>
                </DialogContent>
            </Dialog>
        </React.Fragment >
    );
}